export const fr = {
  marketplacePage: {
    title: 'Marché du Bénévolat',
    not_found: 'Introuvable',
    description: {
      main: "Parcourez les modèles d'activités de bénévolat prêts à utiliser.",
      details:
        "Chacun est entièrement virtuel et pré-rempli avec les détails de l'événement. Il suffit de choisir une date, une heure et la taille de l'équipe, et vous êtes prêt à commencer.",
    },
    legend: {
      suggested_duration: 'Durée Suggérée',
      recommended_capacity: 'Capacité Recommandée',
    },
    event_card: {
      virtual_event: 'Événement Virtuel',
      capacity: '{{min}} - {{max}} Personnes',
      view_template: 'Voir le Modèle',
    },
    event_preview_modal: {
      banner_alt: 'Image de bannière pour {{name}}',
      use_template: 'Utiliser le Modèle',
      capacity_range: '{{min}}-{{max}} personnes',
      nonprofit_logo_alt: 'Logo de l\'Organisation',
      stats: {
        times_partnered: 'FOIS PARTENAIRES',
        hours_volunteered: 'HEURES DE BÉNÉVOLAT',
      },
      sections: {
        about_event: 'À Propos de Cet Événement',
        what_youll_do: 'Ce Que Vous Ferez',
        your_impact: 'Votre Impact',
        about_nonprofit: 'À Propos de {{name}}',
      },
      nonprofit: {
        website: 'SITE WEB',
        about: 'À PROPOS',
      },
      actions: {
        cancel: 'Annuler',
        use_template: 'Utiliser le Modèle',
      },
    },
  },
}